export default class InteractiveCuts {

  constructor() {
    $('[data-cut-target]').on('click', function(e) {
      e.preventDefault();

      // get the cut target ID
      var id = $(this).data('cut-target');
      var $target = $('#'+id);
      var $cut = $('[data-cut-target="'+id+'"');

      // reset currently active classes
      $('.cut-target--active').removeClass('cut-target--active');
      $('[data-cut-target]').removeClass('active');

      // make the current target active
      $target.addClass('cut-target--active');
      $cut.addClass('active');
      $('.cuts').addClass('accordion-active');
    });

    $('.accordion__button').on('click', function() {
      $('a[href="#expand"]').removeClass('hidden');
    });


    $('[data-cut-target]').hover(function() {
      var id = $(this).data('cut-target');
      var $target = $('[data-cut-target="'+id+'"');
      $target.addClass('hover-active');
    }, function() {
      $('[data-cut-target].hover-active').removeClass('hover-active');
    });

    $('a[href="#expand"]').on('click', function(e) {
      e.preventDefault();
      //swindow.target = $(e.target);
      if( $(e.target).hasClass('expanded') ) {
        $(e.target).removeClass('expanded');
        $('.cuts__accordion-button').addClass('collapsed');
        $('.collapse').removeClass('show');
        $(e.target).html('Expand All');
      } else {
        $('.cut-target--active .collapsed').removeClass('collapsed');
        $('.cut-target--active .collapse').addClass('show');
        $(e.target).addClass('expanded');
        $(e.target).html('Collapse All');
      }
    });

    /*****************
    * Product Switch
    *****************/
    $('.product-switch').on('click', function(e) {
      e.preventDefault();
      $('.visible').removeClass('visible');
      $($(this).attr('href')).addClass('visible');
      $('.accordion-active').removeClass('accordion-active');
      $('.cut-target--active').removeClass('cut-target--active');
      $('[data-cut-target]').removeClass('active');
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/interactive-cuts.js